import { ListContext } from 'components/ListsProvider';
import { useContext } from 'react';

const useFields = () => {
    const { fields } = useContext(ListContext);
    return fields;
}

export default useFields;
